
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faArrowDownShortWide, faArrowDownWideShort } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const extraIcons: Record<string, JSX.Element> = {

  SortUp: <FontAwesomeIcon icon={faArrowDownShortWide as IconProp} />,
  SortDown: <FontAwesomeIcon icon={faArrowDownWideShort as IconProp} />,

};

export default extraIcons;